const getChannel = () => {
    if (typeof Sephora === 'undefined') {
        return '';
    }

    try {
        return Sephora?.channel?.toUpperCase() || '';
    } catch (e) {
        Sephora?.logger?.verbose('SuperChat: failed to read Sephora.channel:', e);

        return '';
    }
};

export default getChannel;
